/**
 * Copyright (c) Qwoach LLC 2023. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 1.05.23
 *
 */
import QwoachDataManager from "@/core/js/backend/QwoachDataManager";
import {firebase} from '@/core/js/backend/firebaseConfig'

let dataManager = new QwoachDataManager(firebase, {})
// new QwoachDataManager(firebase, {})

export default dataManager

// export {
// 	dataManagerMe
// }
